// import React, { useEffect, useState, useRef } from 'react';
// import { FiSearch, FiShoppingCart, FiRefreshCw, FiEye, FiCheckCircle, FiClock, FiShoppingBag } from 'react-icons/fi';
// import apiCall from '../helper/apiCall';
// import CartItemsModal from '../components/CartItemsModal';

// const Cart = () => {
//     const [carts, setCarts] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [statusFilter, setStatusFilter] = useState('All'); // e.g., All, Pending, Converted
//     const [searchQuery, setSearchQuery] = useState('');
//     const [isModalOpen, setIsModalOpen] = useState(false);
//     const [selectedCart, setSelectedCart] = useState(null);
//     const [message, setMessage] = useState(null);

//     const inputRef = useRef(null);

//     const fetchCarts = async () => {
//         setLoading(true);
//         try {
//             // Assuming your backend handles these filters
//             const response = await apiCall("getCarts", { statusFilter, searchQuery });
//             if (response?.success) {
//                 setCarts(response.data);
//             }
//         } catch (err) {
//             handleMessage("Failed to fetch carts", true);
//         } finally {
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         fetchCarts();
//     }, [statusFilter]);

//     const handleViewItems = (cart) => {
//         setSelectedCart(cart);
//         setIsModalOpen(true);
//     };

//     const handleMessage = (msg, isError = false) => {
//         setMessage({ text: msg, isError });
//         setTimeout(() => setMessage(null), 3000);
//     };

//     return (
//         <div className="min-h-screen bg-[#f8fafc] p-4 md:p-8 font-sans">
//             <div className="max-w-7xl mx-auto">
                
//                 {/* Header Section */}
//                 <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-6 mb-8">
//                     <div>
//                         <h1 className="text-2xl font-bold text-slate-900 flex items-center gap-2">
//                             <FiShoppingCart className="text-indigo-600" /> Active Shopping Carts
//                         </h1>
//                         <p className="text-slate-500 text-sm mt-1">Monitor live customer carts and conversion statuses.</p>
//                     </div>

//                     <div className="flex flex-col sm:flex-row gap-3 w-full lg:w-auto">
//                         <div className="relative flex-grow">
//                             <FiSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
//                             <input
//                                 ref={inputRef}
//                                 type="text"
//                                 placeholder="Search Cart # or User ID..."
//                                 value={searchQuery}
//                                 onChange={(e) => setSearchQuery(e.target.value)}
//                                 onKeyDown={(e) => e.key === 'Enter' && fetchCarts()}
//                                 className="w-full pl-10 pr-4 py-2.5 bg-white border border-slate-200 rounded-xl focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500 transition-all outline-none shadow-sm"
//                             />
//                         </div>
//                         <button 
//                             onClick={fetchCarts}
//                             className="inline-flex items-center justify-center gap-2 px-4 py-2.5 bg-white border border-slate-200 text-slate-700 rounded-xl hover:bg-slate-50 transition-colors font-medium shadow-sm"
//                         >
//                             <FiRefreshCw className={`${loading ? 'animate-spin' : ''}`} />
//                             <span>Refresh</span>
//                         </button>
//                     </div>
//                 </div>

//                 {/* Main Table Container */}
//                 <div className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden">
//                     <div className="p-4 border-b border-slate-100 bg-slate-50/50 flex items-center justify-between">
//                         <div className="flex bg-slate-200/50 p-1 rounded-lg">
//                             {['All', 'Pending', 'Converted'].map(status => (
//                                 <button
//                                     key={status}
//                                     onClick={() => setStatusFilter(status)}
//                                     className={`px-4 py-1.5 rounded-md text-sm font-semibold transition-all ${
//                                         statusFilter === status 
//                                         ? 'bg-white text-indigo-600 shadow-sm' 
//                                         : 'text-slate-600 hover:text-slate-900'
//                                     }`}
//                                 >
//                                     {status}
//                                 </button>
//                             ))}
//                         </div>
//                         <span className="text-xs font-bold text-slate-400 uppercase tracking-wider">
//                             {carts.length} Active Sessions
//                         </span>
//                     </div>

//                     <div className="overflow-x-auto">
//                         <table className="w-full text-left border-collapse">
//                             <thead>
//                                 <tr className="text-slate-400 text-[11px] uppercase tracking-widest font-bold">
//                                     <th className="px-6 py-4">Cart Info</th>
//                                     <th className="px-6 py-4">Items</th>
//                                     <th className="px-6 py-4">Total Amount</th>
//                                     <th className="px-6 py-4 text-center">Status</th>
//                                     <th className="px-6 py-4 text-right">Actions</th>
//                                 </tr>
//                             </thead>
//                             <tbody className="divide-y divide-slate-100">
//                                 {loading ? (
//                                     <tr><td colSpan="5" className="py-20 text-center">Loading...</td></tr>
//                                 ) : carts.map(cart => (
//                                     <tr key={cart.cart_id} className="hover:bg-slate-50/80 transition-colors group">
//                                         <td className="px-6 py-4">
//                                             <div className="font-semibold text-slate-800">{cart.cart_number || `CART-${cart.cart_id}`}</div>
//                                             <div className="text-xs text-slate-400 mt-0.5">User: {cart.user_id?.substring(0,8)}...</div>
//                                         </td>
//                                         <td className="px-6 py-4">
//                                             <div className="flex items-center gap-2">
//                                                 <FiShoppingBag className="text-slate-400" />
//                                                 <span className="text-sm font-medium text-slate-700">{cart.total_cart_item} items</span>
//                                             </div>
//                                         </td>
//                                         <td className="px-6 py-4">
//                                             <span className="text-sm font-bold text-slate-900">
//                                                 ₹{parseFloat(cart.total_payable_amount).toFixed(2)}
//                                             </span>
//                                         </td>
//                                         <td className="px-6 py-4">
//                                             <div className="flex justify-center">
//                                                 {cart.conversion_status === 'Converted' ? (
//                                                     <div className="flex items-center gap-1.5 text-emerald-600 bg-emerald-50 px-2 py-1 rounded-full text-xs font-bold">
//                                                         <FiCheckCircle /> Ordered
//                                                     </div>
//                                                 ) : (
//                                                     <div className="flex items-center gap-1.5 text-amber-600 bg-amber-50 px-2 py-1 rounded-full text-xs font-bold">
//                                                         <FiClock /> Abandoned
//                                                     </div>
//                                                 )}
//                                             </div>
//                                         </td>
//                                         <td className="px-6 py-4 text-right">
//                                             <button
//                                                 onClick={() => handleViewItems(cart)}
//                                                 className="inline-flex items-center gap-2 text-indigo-600 bg-indigo-50 hover:bg-indigo-600 hover:text-white px-4 py-2 rounded-lg text-sm font-bold transition-all"
//                                             >
//                                                 <FiEye size={16} />
//                                                 View Items
//                                             </button>
//                                         </td>
//                                     </tr>
//                                 ))}
//                             </tbody>
//                         </table>
//                     </div>
//                 </div>
//             </div>

//             {selectedCart && (
//                 <CartItemsModal
//                     show={isModalOpen}
//                     onClose={() => setIsModalOpen(false)}
//                     cartId={selectedCart.cart_id}
//                     cartNumber={selectedCart.cart_number}
//                 />
//             )}
//         </div>
//     );
// }

// export default Cart;

import React, { useEffect, useState, useRef } from 'react';
import { FiSearch, FiShoppingCart, FiRefreshCw, FiEye, FiCheckCircle, FiClock, FiShoppingBag, FiCreditCard, FiTruck, FiAlertCircle } from 'react-icons/fi'; // Added icons
import apiCall from '../helper/apiCall';
import CartItemsModal from '../components/CartItemsModal';

const Cart = () => {
    const [carts, setCarts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [statusFilter, setStatusFilter] = useState('All');
    const [searchQuery, setSearchQuery] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedCart, setSelectedCart] = useState(null);
    const [message, setMessage] = useState(null);

    const inputRef = useRef(null);

    // Helper to render Payment Method Badge
    const renderPaymentMethod = (id) => {
        if (id === 1) {
            return (
                <div className="flex items-center gap-1.5 text-blue-600 bg-blue-50 px-2.5 py-1 rounded-md text-[11px] font-bold border border-blue-100">
                    <FiTruck size={14} /> COD
                </div>
            );
        }
        if (id === 2) {
            return (
                <div className="flex items-center gap-1.5 text-purple-600 bg-purple-50 px-2.5 py-1 rounded-md text-[11px] font-bold border border-purple-100">
                    <FiCreditCard size={14} /> PREPAID
                </div>
            );
        }
        return (
            <div className="flex items-center gap-1.5 text-slate-400 bg-slate-100 px-2.5 py-1 rounded-md text-[11px] font-bold border border-slate-200">
                <FiAlertCircle size={14} /> NOT SELECTED
            </div>
        );
    };

    const fetchCarts = async () => {
        setLoading(true);
        try {
            const response = await apiCall("getCarts", { statusFilter, searchQuery });
            if (response?.success) {
                setCarts(response.data);
            }
        } catch (err) {
            handleMessage("Failed to fetch carts", true);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchCarts();
    }, [statusFilter]);

    const handleViewItems = (cart) => {
        setSelectedCart(cart);
        setIsModalOpen(true);
    };

    const handleMessage = (msg, isError = false) => {
        setMessage({ text: msg, isError });
        setTimeout(() => setMessage(null), 3000);
    };

    return (
        <div className="min-h-screen bg-[#f8fafc] p-4 md:p-8 font-sans">
            <div className="max-w-7xl mx-auto">
                
                {/* Header Section */}
                <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-6 mb-8">
                    <div>
                        <h1 className="text-2xl font-bold text-slate-900 flex items-center gap-2">
                            <FiShoppingCart className="text-indigo-600" /> Active Shopping Carts
                        </h1>
                        <p className="text-slate-500 text-sm mt-1">Monitor live customer carts and conversion statuses.</p>
                    </div>

                    <div className="flex flex-col sm:flex-row gap-3 w-full lg:w-auto">
                        <div className="relative flex-grow">
                            <FiSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
                            <input
                                ref={inputRef}
                                type="text"
                                placeholder="Search Cart # or User ID..."
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                onKeyDown={(e) => e.key === 'Enter' && fetchCarts()}
                                className="w-full pl-10 pr-4 py-2.5 bg-white border border-slate-200 rounded-xl focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500 transition-all outline-none shadow-sm"
                            />
                        </div>
                        <button 
                            onClick={fetchCarts}
                            className="inline-flex items-center justify-center gap-2 px-4 py-2.5 bg-white border border-slate-200 text-slate-700 rounded-xl hover:bg-slate-50 transition-colors font-medium shadow-sm"
                        >
                            <FiRefreshCw className={`${loading ? 'animate-spin' : ''}`} />
                            <span>Refresh</span>
                        </button>
                    </div>
                </div>

                {/* Main Table Container */}
                <div className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden">
                    <div className="p-4 border-b border-slate-100 bg-slate-50/50 flex items-center justify-between">
                        <div className="flex bg-slate-200/50 p-1 rounded-lg">
                            {['All', 'Pending', 'Converted'].map(status => (
                                <button
                                    key={status}
                                    onClick={() => setStatusFilter(status)}
                                    className={`px-4 py-1.5 rounded-md text-sm font-semibold transition-all ${
                                        statusFilter === status 
                                        ? 'bg-white text-indigo-600 shadow-sm' 
                                        : 'text-slate-600 hover:text-slate-900'
                                    }`}
                                >
                                    {status}
                                </button>
                            ))}
                        </div>
                        <span className="text-xs font-bold text-slate-400 uppercase tracking-wider">
                            {carts.length} Active Sessions
                        </span>
                    </div>

                    <div className="overflow-x-auto">
                        <table className="w-full text-left border-collapse">
                            <thead>
                                <tr className="text-slate-400 text-[11px] uppercase tracking-widest font-bold">
                                    <th className="px-6 py-4">Cart Info</th>
                                    <th className="px-6 py-4">Items</th>
                                    <th className="px-6 py-4">Payment Method</th> {/* NEW COLUMN */}
                                    <th className="px-6 py-4">Total Amount</th>
                                    <th className="px-6 py-4 text-center">Status</th>
                                    <th className="px-6 py-4 text-right">Actions</th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-slate-100">
                                {loading ? (
                                    <tr><td colSpan="6" className="py-20 text-center">Loading...</td></tr>
                                ) : carts.map(cart => (
                                    <tr key={cart.cart_id} className="hover:bg-slate-50/80 transition-colors group">
                                        <td className="px-6 py-4">
                                            <div className="font-semibold text-slate-800">{cart.cart_number || `CART-${cart.cart_id}`}</div>
                                            <div className="text-xs text-slate-400 mt-0.5">User: {cart.user_id?.substring(0,8)}...</div>
                                        </td>
                                        <td className="px-6 py-4">
                                            <div className="flex items-center gap-2">
                                                <FiShoppingBag className="text-slate-400" />
                                                <span className="text-sm font-medium text-slate-700">{cart.total_cart_item} items</span>
                                            </div>
                                        </td>
                                        <td className="px-6 py-4">
                                            {/* Render the Payment Badge */}
                                            {renderPaymentMethod(cart.payment_method_id)}
                                        </td>
                                        <td className="px-6 py-4">
                                            <span className="text-sm font-bold text-slate-900">
                                                ₹{parseFloat(cart.total_payable_amount).toFixed(2)}
                                            </span>
                                        </td>
                                        <td className="px-6 py-4">
                                            <div className="flex justify-center">
                                                {cart.conversion_status === 'Converted' ? (
                                                    <div className="flex items-center gap-1.5 text-emerald-600 bg-emerald-50 px-2 py-1 rounded-full text-xs font-bold">
                                                        <FiCheckCircle /> Ordered
                                                    </div>
                                                ) : (
                                                    <div className="flex items-center gap-1.5 text-amber-600 bg-amber-50 px-2 py-1 rounded-full text-xs font-bold">
                                                        <FiClock /> Abandoned
                                                    </div>
                                                )}
                                            </div>
                                        </td>
                                        <td className="px-6 py-4 text-right">
                                            <button
                                                onClick={() => handleViewItems(cart)}
                                                className="inline-flex items-center gap-2 text-indigo-600 bg-indigo-50 hover:bg-indigo-600 hover:text-white px-4 py-2 rounded-lg text-sm font-bold transition-all"
                                            >
                                                <FiEye size={16} />
                                                View Items
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            {selectedCart && (
                <CartItemsModal
                    show={isModalOpen}
                    onClose={() => setIsModalOpen(false)}
                    cartId={selectedCart.cart_id}
                    cartNumber={selectedCart.cart_number}
                />
            )}
        </div>
    );
}

export default Cart;